import React from "react";
import { Icon } from "@culturehq/components";
import { Trans } from "app/utils";
import { IconName } from "@culturehq/components/dist/components/Icon";

interface TipProps {
  message: React.ReactNode;
  icon?: IconName;
  SvgIcon?: React.ReactNode;
}

const Tip: React.FC<TipProps> = ({
  message,
  icon,
  SvgIcon
}) => (
  <div className="TipContainer">
    {icon && <Icon icon={icon} />}
    {SvgIcon && SvgIcon}
    <p>
      <Trans>{message}</Trans>
    </p>
  </div>
);

export default Tip;
